<template>
  <div class="investTeam">
    <topNav></topNav>
    <!-- 首页图片 -->
    <div class="bigPicture">
      <!-- <el-carousel trigger="click" class="bannerMain" v-show="banners.length>1">
        <el-carousel-item v-for="(item,index) in banners" :key="index">
          <div class="bannerimg">
            <img :src="item" class="bannerimg" alt="" />
          </div>
        </el-carousel-item>
      </el-carousel> -->
      <!-- <img :src="banners[0]" v-show="banners.length<=1" class="bannerimg" alt="" /> -->
      <el-carousel trigger="click" class="bannerMain" v-show="banners.length>1">
        <el-carousel-item v-for="(item,index) in banners" :key="index">
          <div class="bannerimg">
            <img :src="item" class="bannerimg" alt="" @load="loadImg1" />
            <!-- <a v-if="index == 0" href="https://www.dexunzhenggu.cn/h5/html/showimg.html?id=1" target="_blank"></a> -->
            <!-- <img :src="item.imgSrc" class="bannerimg" alt="" />
            <a v-if="item.to" :href="item.url" target="_blank"></a> -->
          </div>
        </el-carousel-item>
      </el-carousel>
      <img v-show="banners.length<=1" @load="loadImg1" :src="banners[0]" class="bannerimg" alt="加载中..." />
      
    </div>
    <!-- <div class="intro">
      德讯证顾汇聚业内顶尖人才,拥有经验丰富的互联网大数据研发团队现有持牌投资顾问50余人,超20人的资深投顾投研团队,秉持以客户为中心,专业、诚信的原则,持续优化研究能力,为广大投资者提供公正、独立客观的全方位金融服务。
    </div> -->
    <div class="intro">
      <div
        v-for="item in touyanLanmu"
        :key="item.id"
        @click="checkedIntro(item)"
        class="introTitle"
        :id="introIndex == item.id ? 'introTitle' : ''"
      >
        {{ item.name }}
      </div>
      <div class="introBorder"></div>
    </div>

    <div style="margin: auto;max-width: 1920px;">
      <div class="teacherCard" v-show="touyanTuandui.length>1">
        <div
          v-for="item in touyanTuandui"
          :key="item.team.IrTeam.id"
          class="teacherCardIndex"
          :id="
            teacherCardIndex == item.team.IrTeam.id ? 'teacherCardIndex' : ''
          "
          @click="checkedTeacher(item)"
        >
          {{ item.team.IrTeam.name }}
        </div>
      </div>
      <div style="height:20px;" v-show="touyanTuandui.length<=1"></div>
      <!-- 罗老师介绍 v-loading="loading" element-loading-text="拼命加载中"-->
      <div v-for="(item, index) in touyanCY" :key="index">
        <div class="teacher" id="teacherLJ">
          <div class="demobox bigNav">
            <el-carousel trigger="click" class="bannerMain2" :interval="10000" v-show="item.team.IrTeam.pictures.length>1">
              <el-carousel-item
                v-for="(item2, index) in item.team.IrTeam.pictures"
                :key="index"
              >
                <div class="bannerimg">
                  <!-- <img :src="item2" class="bannerimg" alt="" /> -->
                      <el-image class="bannerimg" @load="loadImg2" :src="item2"></el-image>
                </div>
              </el-carousel-item>
            </el-carousel>
            
            <div v-show="loading">
              <img v-show="item.team.IrTeam.pictures.length<=1" @load="loadImg2" :src="item.team.IrTeam.pictures[0]" class="bannerimg" alt="" />
            </div>
            
            <div v-show="loading==false" class="bannerimg"></div>
          </div>
        </div>
        <!-- 视频介绍 -->
        <div class="vid" v-show="item.team.IrTeam.videos">
          <div class="title">
            <div class="txtStyle">视频介绍</div>
            <div class="imgStyle"></div>
          </div>
          <div class="boxin banmain videoDAbox">
            <video
              class="videoDA"
              id="videoDA"
              controls
              :src="item.team.IrTeam.videos"
              type="video/mp4"
            ></video>
            <div class="play" v-if="palyDA" id="play" @click="DAplay">
              <img
                src="../common/images/productCenter/A1/paly.png"
                id="playbtn"
                class="playbtn"
                alt=""
              />
            </div>
            <img
              src="../common/images/productCenter/A1/palying.png"
              class="playing"
              v-if="playingA"
              alt=""
            />
          </div>
        </div>
        <!-- 团队介绍 -->
        <div class="team" id="teamBJ1">
          <div class="demobox bigNav">
            <el-carousel trigger="click" class="bannerMain3" :interval="10000" v-show="item.team.IrTeam.features.length>1">
              <el-carousel-item
                v-for="(item3, index) in item.team.IrTeam.features"
                :key="index"
              >
                <div>
                  <img :src="item3" class="bannerimgtd" @load="loadImg(2)" alt="" />
                </div>
              </el-carousel-item>
            </el-carousel>
            <img :src="item.team.IrTeam.features[0]" v-show="item.team.IrTeam.features.length<=1" class="bannerimgtd" alt="" />
          </div>
        </div>
        <!-- 成员介绍 -->
        <div class="member">
          <div class="title">
            <div class="txtStyle" style="line-height: 164px">团队成员</div>
            <div class="imgStyle" style="top: 80px"></div>
          </div>
          <div class="memberS">
            <el-carousel
              :interval="4000"
              type="card"
              height=""
              style="width: 1500px"
            >
              <el-carousel-item v-for="item4 in item.t_sons" :key="item4.id">
                <!-- <img :src="item4.pictures" class="bannerimg2" alt=""> -->
                <img
                  :src="item4.pictures"
                  class="bannerimg3"
                  alt=""
                  @load="loadImg(3)"
                />
              </el-carousel-item>
            </el-carousel>
            </div> 
          </div>
        </div>
      </div>
    <Bottoms></Bottoms>
  </div>
</template>
<script>
import topNav from "./sub/topNav";
import Bottoms from "./sub/Bottoms";
import { videoPlayer } from "vue-video-player";
import { l } from "@/utils/tool";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import { investResearchList, irTeamList } from "@/api/investTeam";
import { colunmList,productList,columnTypeList } from "@/api/topNav.js";
export default {
  name: "investTeam",
  components: { topNav, Bottoms, videoPlayer },
  data() {
    return {
      banners:[],
      introIndex: 0,
      teacherCardIndex: 3,
      palyDA: true,
      palyDB: true,
      palyDC: true,
      palyDD: true,
      playingA: false,
      playingB: false,
      playingC: false,
      playingD: false,

      teamLJ: [
        {
          id: "0",
          name: "雷奥辉",
          lv: "高级投资顾问",
          number: "执业编号：A1050619060001",
          url: require("@/common/images/investTeam/memberLAH.png"),
        },
        {
          id: "3",
          name: "林郭维",
          lv: "高级投资顾问",
          number: "执业编号：A1050622050001",
          url: require("@/common/images/investTeam/memberLGW.png"),
        },
        {
          id: "1",
          name: "钟庆风",
          lv: "投资顾问",
          number: "执业编号：A1050620020001",
          url: require("@/common/images/investTeam/memberZQF.png"),
        },
        {
          id: "2",
          name: "刘文星",
          lv: "投资顾问",
          number: "执业编号：A1050619080002",
          url: require("@/common/images/investTeam/memberLWX.png"),
        },
        /* {
          id: "3",
          name: "余小林",
          lv: "高级投资顾问",
          number: "执业编号：A1050620090001",
          url: require("@/common/images/investTeam/memberXXL.png"),
        }, */
        /* {
          id: "4",
          name: "孙泽禹",
          lv: "投资顾问",
          number: "执业编号：A1050622070001",
          url: require("@/common/images/investTeam/memberSZY.png"),
        }, */
      ],
      teamLJ_two: [
        {
          id: "0",
          name: "林郭维",
          lv: "投资顾问",
          number: "执业编号：A1050622050001",
          url: require("@/common/images/investTeam/memberLGW.png"),
        },
      ],
      teamWM: [
        // {
        //   id: "0",
        //   name: "雷奥辉",
        //   lv: "高级投资顾问",
        //   number: "执业编号：A1050619060001",
        //   url: require("@/common/images/investTeam/memberLAH.png"),
        // },
        /* {
          id: "0",
          name: "刘秋菊",
          lv: "高级投资顾问",
          number: "执业编号：A1050619080006",
          url: require("@/common/images/investTeam/memberLQJ.png"),
        },
       
        {
          id: "1",
          name: "李成明",
          lv: "投资顾问",
          number: "执业编号：A1050622010001",
          url: require("@/common/images/investTeam/memberLCM.png"),
        }, */
        /* {
          id: "1",
          name: "刘聪",
          lv: "投资顾问",
          number: "执业编号：A1050622040002",
          url: require("@/common/images/investTeam/memberLC.png"),
        }, */
        {
          id: "1",
          name: "刘飞武",
          lv: "投资顾问",
          number: "执业编号：A1050621070002",
          url: require("@/common/images/investTeam/memberLFW.png"),
        },
      ],
      teamWM_two: [
        {
          id: "0",
          name: "刘聪",
          lv: "投资顾问",
          number: "执业编号：A1050622040002",
          url: require("@/common/images/investTeam/memberLC.png"),
        },
      ],
      teamRSW: [
        {
          id: "0",
          name: "邓慧华",
          lv: "高级投资顾问",
          number: "执业编号：A1050621120007",
          url: require("@/common/images/investTeam/memberDHH.png"),
        },
        {
          id: "1",
          name: "董法",
          lv: "高级投资顾问",
          number: "执业编号：A1050620060001",
          url: require("@/common/images/investTeam/memberDF.png"),
        },
        {
          id: "2",
          name: "杨显政",
          lv: "投资顾问",
          number: "执业编号：A1050621080002",
          url: require("@/common/images/investTeam/memberYXZ.png"),
        },
        // {
        //   id: "3",
        //   name: "贾涛",
        //   lv: "投资顾问",
        //   number: "执业编号：A1050622040003",
        //   url: require("@/common/images/investTeam/memberJT.png"),
        // },
        {
          id: "3",
          name: "刘阿洋",
          lv: "投资顾问",
          number: "执业编号：A1050622010002 ",
          url: require("@/common/images/investTeam/memberLAY.png"),
        },
        {
          id: "4",
          name: "张领风",
          lv: "投资顾问",
          number: "执业编号：A1050621120009",
          url: require("@/common/images/investTeam/memberZLF.png"),
        },
      ],
      teamCJW: [
        {
          id: "0",
          name: "余小林",
          lv: "高级投顾研究员",
          number: "执业编号：A1050620090001",
          url: require("@/common/images/investTeam/memberYXL.png"),
        },
        {
          id: "1",
          name: "赖达旺",
          lv: "高级投顾研究员",
          number: "执业编号：A1050621090003",
          url: require("@/common/images/investTeam/memberLDW.png"),
        },
        {
          id: "2",
          name: "吴一凡",
          lv: "投资顾问",
          number: "执业编号：A1050622100002",
          url: require("@/common/images/investTeam/memberWYF.png"),
        },
        {
          id: "3",
          name: "刘飞武",
          lv: "投资顾问",
          number: "执业编号：A1050621070002",
          url: require("@/common/images/investTeam/memberLFW.png"),
        },
        {
          id: "4",
          name: "郭英儒",
          lv: "投顾助理",
          number: "执业编号：A1050123040034",
          url: require("@/common/images/investTeam/cc3f0f2573ab0732618dbccec321770.png"),
        },
        {
          id: "2",
          name: "向波",
          lv: "投资顾问",
          number: "执业编号：A1050621120008",
          url: require("@/common/images/investTeam/memberXB.png"),
        },
        /*  {
          id: "3",
          name: "周文清",
          lv: "投资顾问",
          number: "执业编号：A1050622070002",
          url: require("@/common/images/investTeam/memberZWQ.png"),
        } */
      ],
      teamZJK: [
        /* {
          id: "0",
          name: "王运泉",
          lv: "投顾研究员",
          number: "执业编号：A1050621110001",
          url: require("@/common/images/investTeam/member_WYQ.png"),
          // url: require("../common/images/investTeam/memberXXL.png"),
        }, */
        {
          id: "1",
          name: "蔡满强",
          lv: "高级投顾研究员",
          number: "执业编号：A1050621040002",
          url: require("@/common/images/investTeam/memberZJK_CMQ.png"),
          // url: require("../common/images/investTeam/memberXXL.png"),
        },
        {
          id: "2",
          name: "朱小飞",
          lv: "高级投顾研究员",
          number: "执业编号：A1050621070003",
          url: require("@/common/images/investTeam/memberZJK_ZXF.png"),
        },
        {
          id: "3",
          name: "李天生",
          lv: "投顾研究员",
          number: "执业编号：A1050621120002",
          url: require("@/common/images/investTeam/memberZJK_LTS.png"),
        },
        {
          id: "4",
          name: "梅雪",
          lv: "投顾研究员",
          number: "执业编号：A1050621090002",
          url: require("@/common/images/investTeam/memberZJK_MX.png"),
        },
        {
          id: "5",
          name: "胡俊民",
          lv: "高级投顾研究员",
          number: "执业编号：A1050621040001",
          url: require("@/common/images/investTeam/memberZJK_HJM.png"),
        },
      ],
      teamZJK_Two: [
        /* {
          id: "0",
          name: "胡俊民",
          lv: "高级投顾研究员",
          number: "执业编号：A1050621040001",
          url: require("@/common/images/investTeam/memberZJK_HJM.png"),
        }, */
        /* {
          id: "1",
          name: "周子扬",
          lv: "投顾研究员",
          number: "执业编号：A1050622030001",
          url: require("@/common/images/investTeam/memberZZY.png"),
        }, */
        {
          id: "2",
          name: "杨捷震",
          lv: "投顾研究员",
          number: "执业编号：A1050622040004",
          url: require("@/common/images/investTeam/memberYJZ.png"),
        },
        /* {
          id: "3",
          name: "刘鹏",
          lv: "投顾研究员",
          number: "执业编号：A1050622040001",
          url: require("@/common/images/investTeam/memberLP.png"),
        }, */
        {
          id: "4",
          name: "李尚鑫",
          lv: "投顾研究员",
          number: "执业编号：A1050622050003",
          url: require("@/common/images/investTeam/memberLSX.png"),
        },
        {
          id: "5",
          name: "刘东灵",
          lv: "投顾研究员",
          number: "执业编号：A1050623040004",
          url: require("@/common/images/investTeam/memberLDL.png"),
        },
        {
          id: "6",
          name: "朱金发",
          lv: "投顾研究员",
          number: "执业编号：A1050623040005",
          url: require("@/common/images/investTeam/memberZJF.png"),
        },
      ],
      memberCardBoxLJ: "left: 0%",
      memberCardBoxWM: "left: 0%",
      memberCardBoxZJK: "left: 0%",
      showmemberR_WM: true,
      showmemberL_WM: false,
      showmemberR_LJ: true,
      showmemberL_LJ: false,
      showmemberR_ZJK: true,
      showmemberL_ZJK: false,
      needData: [],
      currentPage: 1, //初始页
      courseId: "", //后端需要的参数，看个人是否需要
      pageSize: 10, //每页的数据
      pageNum: 1, //后端需要的参数，看个人是否需要
      tableData: [], //定义一个数组，用来接收后端返回的内容
      touyanLanmu: [], //投研栏目数组
      touyanTuandui: [], //投研栏目数组
      touyanCY: [],
      loading:false,
    };
  },
  methods: {
    checkedIntro: function (item) {
      //点击栏目
      // this.introIndex = item;
      this.introIndex = item.id;
      this.touyanFuc(item.id);
      this.palyDA = true;
      this.DAplayState();
      this.loading = false;
    },
    checkedTeacher: function (item) {
      //点击团队
      this.teacherCardIndex = item.team.IrTeam.id;
      this.touyanCY = [];
      // let index = this.touyanTuandui.findIndex(
      //   (v) => v.team.IrTeam.id == item.team.IrTeam.id
      // );
      this.touyanCY.push(item);
      this.palyDA = true;
      
      this.DAplayState();
      // this.touyanCY.forEach((v2) => {
      //   v2.team.IrTeam.pictures = v2.team.IrTeam.pictures.split(",");
      // });
      
      // console.log(item);
      // if (item == 0) {
      //   setTimeout(() => {
      //     this.DBplayState();
      //   }, 100);
      // }
      // if (item == 1) {
      //   setTimeout(() => {
      //     this.DAplayState();
      //   }, 100);
      // }
      // // DAplayState
      // if (item == 2) {
      //   setTimeout(() => {
      //     this.DCplayState();
      //   }, 100);
      // }
      // if (item == 3) {
      //   setTimeout(() => {
      //     this.DDplayState();
      //   }, 100);
      // }
      // l('团');
      this.loading = false;
    },
    loadImg(item){ //图片加载完成后
      // l(item);
    },
    //滑动轮播
    memberL() {
      var item = this.teamLJ;
      var length = item.length;
      item[length] = item[0];
      item.splice(0, 1);
    },
    memberR() {
      var item = this.teamLJ;
      var length = item.length;
      item.splice(0, 0, item[length - 1]);
      item.splice(length, 1);
    },
    memberL_LJ() {
      this.memberCardBoxLJ = "left: 0%;  ";
      this.showmemberR_LJ = true;
      this.showmemberL_LJ = false;
    },
    memberR_LJ() {
      this.memberCardBoxLJ = "left: -100%;  ";
      this.showmemberR_LJ = false;
      this.showmemberL_LJ = true;
    },
    memberL_WM() {
      this.memberCardBoxWM = "left: 0%;  ";
      this.showmemberR_WM = true;
      this.showmemberL_WM = false;
      // var item = this.teamWM;
      // var length = item.length;
      // item[length] = item[0];
      // item.splice(0, 1);
    },
    memberR_WM() {
      this.memberCardBoxWM = "left: -100%;  ";
      this.showmemberR_WM = false;
      this.showmemberL_WM = true;
      // var item = this.teamWM;
      // var length = item.length;
      // item.splice(0, 0, item[length - 1]);
      // item.splice(length, 1);
    },
    memberL_RSW() {
      var item = this.teamRSW;
      var length = item.length;
      item[length] = item[0];
      item.splice(0, 1);
    },
    memberR_RSW() {
      var item = this.teamRSW;
      var length = item.length;
      item.splice(0, 0, item[length - 1]);
      item.splice(length, 1);
    },
    memberL_ZJK() {
      this.memberCardBoxZJK = "left: 0%;  ";
      this.showmemberR_ZJK = true;
      this.showmemberL_ZJK = false;
      // var item = this.teamZJK;
      // var length = item.length;
      // item[length] = item[0];
      // item.splice(0, 1);
    },
    memberR_ZJK() {
      this.memberCardBoxZJK = "left: -100%;  ";
      this.showmemberR_ZJK = false;
      this.showmemberL_ZJK = true;
      // this.memberCardBoxZJK = 'transform: translateX(0px)   '
      // var item = this.teamZJK;
      // var length = item.length;
      // item.splice(0, 0, item[length - 1]);
      // item.splice(length, 1);
    },
    // 分頁
    // currentChangeHandle(val) {
    //   this.currentPage = val;
    //   this.getdata();
    //   console.log(val);
    // },
    // getdata() {
    //   var data = this.showMember;
    //   var currentPage = this.currentPage;
    //   var result = [];
    //   for (var i = 0, len = data.length; i < len; i += 5) {
    //     result.push(data.slice(i, i + 5));
    //   }
    //   console.log("分割后的数据", result);
    //   this.needData = result[currentPage - 1];
    // },
    // 视频
    DAplay: function () {
      let video = document.getElementById("videoDA");
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },
    DBplay: function () {
      let video = document.getElementById("videoDB");
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },
    DCplay: function () {
      let video = document.getElementById("videoDC");
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },
    DDplay: function () {
      //点击常建武老师开始视频
      let video = document.getElementById("videoDD");
      // console.log(video.paused,'video');
      if (video.paused) {
        video.play();
        // that.palyDD = false;
        // this.palyDD = false;
      } else {
        video.pause();
        // this.palyDD = true;
      }
    },
    DAplayState: function () {
      //点击罗军老师开始视频
      let that = this;
      let ele = document.getElementById("videoDA");
      if (ele) {
        ele.addEventListener("play", function () {
          //播放开始执行的函数
          //console.log(1);
          that.palyDA = false;
          that.playingA = true;
          let s = setTimeout(function () {
            that.playingA = false;
            clearTimeout(s);
          }, 1000);
        });
        ele.addEventListener("pause", function () {
          //暂停开始执行的函数
          //console.log(0);
          that.palyDA = true;
        });
      }
    },
    DBplayState: function () {
      let that = this;
      let ele = document.getElementById("videoDB");
      ele.addEventListener("play", function () {
        //播放开始执行的函数
        //console.log(1);
        that.palyDB = false;
        that.playingB = true;
        let s = setTimeout(function () {
          that.playingB = false;
          clearTimeout(s);
        }, 1000);
      });
      ele.addEventListener("pause", function () {
        //暂停开始执行的函数
        //console.log(0);
        that.palyDB = true;
      });
    },
    DCplayState: function () {
      let that = this;
      let ele = document.getElementById("videoDC");
      ele.addEventListener("play", function () {
        //播放开始执行的函数
        //console.log(1);
        that.palyDC = false;
        that.playingC = true;
        let s = setTimeout(function () {
          that.playingC = false;
          clearTimeout(s);
        }, 1000);
      });
      ele.addEventListener("pause", function () {
        //暂停开始执行的函数
        //console.log(0);
        that.palyDC = true;
      });
    },
    DDplayState: function () {
      let that = this;
      let ele = document.getElementById("videoDD");
      ele.addEventListener("play", function () {
        //播放开始执行的函数
        console.log(1);
        that.palyDD = false;
        that.playingD = true;
        let s = setTimeout(function () {
          that.playingD = false;
          clearTimeout(s);
        }, 1000);
      });
      ele.addEventListener("pause", function () {
        //暂停开始执行的函数
        //console.log(0);
        that.palyDD = true;
      });
    },
    selectf() {
      //初始方法
      investResearchList({ status: 1 }).then((res) => {
        //投研栏目列表
        if (res.code == 200) {
          // l(res);
          this.touyanLanmu = res.data.list;
          this.checkedIntro(res.data.list[0]);
          this.touyanFuc(res.data.list[0].id);
          
        }
      });
        colunmList({ column_name:'投研中心' }).then((res) => { //产品管理列表
        //列表
        if (res.code == 200 && res.data.list) {
          // l(res,'ds');
          this.banners = res.data.list[0].pictures.split(',');
        }
      });
    },
    touyanFuc(id) {
      
      irTeamList({ status: 1, ir_research_id: id }).then((res2) => {
        //团队列表
        if (res2.code == 200) {
          this.touyanCY = [];
          this.touyanTuandui = res2.data.list;
          res2.data.list.forEach((v2) => {
            v2.team.IrTeam.pictures = v2.team.IrTeam.pictures.split(","); //团队bran
            v2.team.IrTeam.features = v2.team.IrTeam.features.split(","); //团队特色
            
          });

          this.touyanCY.push(res2.data.list[0]);
          // this.touyanCY.push(res2.data.list);
          this.teacherCardIndex = res2.data.list[0].team.IrTeam.id;
          this.DAplayState();
        }
      });
    },
    loadImg1(){ //栏目brannch
    this.loading = true;
      // l('团队brannch');
    },
    loadImg2(){ //团队brannch
      this.loading = true;
      // l('栏目brannch');
    },
  },
  mounted() {
    // this.getdata();
    window.scrollTo(0, 0);
    this.selectf();
    var index = this.$route.query.index;
    if (index == 1) {
      this.introIndex = 0;
    } else if (index == 2) {
      this.introIndex = 1;
    }
    // this.DBplayState();
    // this.DCplayState();
    // this.DDplayState();
    // this.$nextTick(()=>{
    //   this.DAplayState();
    // })
  },
  computed: {},
};
</script>

<style scoped>
* {
  text-align: center;
}
.investTeam{
  overflow: hidden;
}
.bigPicture {
  width: 1920px;
  height: 580px;
  /* background-color: #ccc; */
  opacity: 1;
  /* background: url("../common/images/investTeam/top1.png") no-repeat; */
  background-size: 100% 100%;
  margin: auto;
}
.bannerMain >>> .el-carousel__container {
  width: 100%;
  height: 580px !important;
}
.bannerMain2 >>> .el-carousel__container {
  width: 100%;
  height: 580px !important;
}
.bannerMain3 >>> .el-carousel__container {
  width: 100%;
  height: 664px !important;
}
.bannerimgtd{
  display: block;
  /* width: 100%; */
  max-width: 1920px;
  height: 664px !important;
  position: relative;
  margin: auto;
}
.bannerimg {
  display: block;
  /* width: 100%; */
  max-width: 1920px;
  height: 580px !important;
  position: relative;
  margin: auto;
}
.bannerimg2 {
  display: block;
  /* width: 100%; */
  max-width: 1920px;
  height: 580px !important;
  position: relative;
  margin: auto;
}
.bannerimg3 {
  display: block;
  /* width: 300px; */
  height: 272px;
  position: relative;
  margin: auto;
}
/* 老师介绍 */
.teacher {
  position: relative;
  width: 100%;
  height: 580px;
  /* background-color: #ccc; */
  opacity: 1;
}
#teacherLJ {
  /* background: url("../common/images/investTeam/teacherLJ.png") no-repeat; */
  background-size: 100% 100%;
}
#teacherWM {
  background: url("../common/images/investTeam/teacherWM.png") no-repeat;
  background-size: 100% 100%;
}
#teacherRSW {
  background: url("../common/images/investTeam/teacherRSW.png") no-repeat;
  background-size: 100% 100%;
}
#teacherZJK {
  background: url("../common/images/investTeam/teacherZJK.png") no-repeat;
  background-size: 100% 100%;
}
#teacherCJW {
  background: url("../common/images/investTeam/teacherCJW.png") no-repeat;
  background-size: 100% 100%;
}
.nameA {
  position: absolute;
  top: 30px;
  left: 520px;
  width: 95px;
  height: 95px;
  font-size: 56px;
  font-family: Source Han Serif CN;
  font-weight: bold;
  line-height: 95px;
  color: #ffffff;
  opacity: 1;
  background: url("../common/images/investTeam/teacher.png") no-repeat;
}
#nameAW {
  top: 30px;
  left: 546px;
}
#nameAM {
  top: 30px;
  left: 691px;
}
.nameB {
  position: absolute;
  top: 30px;
  left: 665px;
  width: 95px;
  height: 95px;
  font-size: 56px;
  font-family: Source Han Serif CN;
  font-weight: bold;
  line-height: 95px;
  color: #ffffff;
  opacity: 1;
  background: url("../common/images/investTeam/teacher.png") no-repeat;
}
.nameC {
  position: absolute;
  top: 30px;
  left: 1040px;
  width: 95px;
  height: 95px;
  font-size: 56px;
  font-family: Source Han Serif CN;
  font-weight: bold;
  line-height: 80px;
  color: #ffffff;
  opacity: 1;
  background: url("../common/images/investTeam/teacher.png") no-repeat;
}
.nameD {
  position: absolute;
  top: 30px;
  left: 1155px;
  width: 95px;
  height: 95px;
  font-size: 56px;
  font-family: Source Han Serif CN;
  font-weight: bold;
  line-height: 80px;
  color: #ffffff;
  opacity: 1;
  background: url("../common/images/investTeam/teacher.png") no-repeat;
}
.nameE {
  position: absolute;
  top: 30px;
  left: 1270px;
  width: 95px;
  height: 95px;
  font-size: 56px;
  font-family: Source Han Serif CN;
  font-weight: bold;
  line-height: 80px;
  color: #ffffff;
  opacity: 1;
  background: url("../common/images/investTeam/teacher.png") no-repeat;
}
.nameF {
  position: absolute;
  top: 30px;
  left: 1058px;
  width: 95px;
  height: 95px;
  font-size: 56px;
  font-family: Source Han Serif CN;
  font-weight: bold;
  line-height: 98px;
  color: #ffffff;
  opacity: 1;
  background: url("../common/images/investTeam/teacher.png") no-repeat;
}
.nameG {
  position: absolute;
  top: 30px;
  left: 1173px;
  width: 95px;
  height: 95px;
  font-size: 56px;
  font-family: Source Han Serif CN;
  font-weight: bold;
  line-height: 98px;
  color: #ffffff;
  opacity: 1;
  background: url("../common/images/investTeam/teacher.png") no-repeat;
}
.nameH {
  position: absolute;
  top: 30px;
  left: 1288px;
  width: 95px;
  height: 95px;
  font-size: 56px;
  font-family: Source Han Serif CN;
  font-weight: bold;
  line-height: 98px;
  color: #ffffff;
  opacity: 1;
  background: url("../common/images/investTeam/teacher.png") no-repeat;
}
.tougu {
  box-sizing: border-box;
  display: flex;
  position: absolute;
  top: 137px;
  left: 512px;
  width: 256px;
  height: 46px;
  background: #f24b46;
  border: 1px solid #ff5b65;
  opacity: 1;
  border-radius: 4px;
  letter-spacing: 2px;
}
#touguWM {
  width: 269px;
  top: 137px;
  left: 532px;
}
#touguRSW {
  width: 269px;
  font-size: 26px;
  left: 1068px;
}
#touguZJK {
  width: 296px;
  height: 50px;
  font-size: 26px;
  top: 139px;
  left: 1073px;
  letter-spacing: 4px;
}
.tougu1 {
  width: 30px;
  height: 30px;
  background: url("../common/images/investTeam/teacher1.png") no-repeat;
  margin: 8px 14px 0 14px;
}
.tougu2 {
  width: 0px;
  height: 12px;
  border: 1px solid #ffffff;
  opacity: 1;
  margin-top: 19px;
}
.tougu3 {
  /* width: 192px; */
  height: 33px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 33px;
  color: #ffffff;
  opacity: 1;
  margin: 7px 0 0 14px;
}
#tougu3WM {
  font-size: 26px;
  letter-spacing: 2px;
  margin: 5px 0 0 17px;
}
.bianhao {
  display: flex;
  position: absolute;
  top: 195px;
  left: 433px;
  width: 415px;
  height: 46px;
  background: rgba(249, 190, 119, 0.24);
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #f9be77;
  opacity: 1;
  border-radius: 4px;
}
#bianhaoWM {
  width: 442px;
  top: 195px;
  left: 445px;
}
#bianhaoRSW {
  width: 436px;
  top: 195px;
  left: 985px;
}
#bianhaoZJK {
  width: 442px;
  top: 195px;
  top: 199px;
  left: 1000px;
  letter-spacing: 1px;
}
.bianhao1 {
  width: 30px;
  height: 30px;
  background: url("../common/images/investTeam/teacher2.png") no-repeat;
  margin: 8px 14px 0 14px;
}
.bianhao2 {
  width: 0px;
  height: 12px;
  border: 1px solid #f9be77;
  opacity: 1;
  margin-top: 17px;
}
.bianhao3 {
  /* width: 323px; */
  height: 33px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 33px;
  color: #f9be77;
  opacity: 1;
  margin: 7px 0 0 14px;
}
#bianhao3WM {
  font-size: 26px;
}
.tzms {
  position: absolute;
  top: 253px;
  left: 445px;
  width: 442px;
  height: 71px;
  background: url("../common/images/investTeam/tzms.png") no-repeat;
}
.gshhj {
  position: absolute;
  top: 279px;
  left: 420px;
  width: 454px;
  height: 34px;
  background: url("../common/images/investTeam/teacher3.png") no-repeat;
}
.first {
  position: absolute;
  top: 261px;
  left: 915px;
  width: 577px;
  height: 71px;
  background: url("../common/images/investTeam/first.png") no-repeat;
}
.duizhang {
  position: absolute;
  top: 265px;
  left: 999px;
  width: 443px;
  height: 71px;
  background: url("../common/images/investTeam/duizhang.png") no-repeat;
}
.border {
  position: absolute;
  width: 462px;
  height: 0px;
  border: 1px solid #ac905d;
  opacity: 1;
}
#borderA {
  top: 261px;
  left: 416px;
}
#borderB {
  top: 331px;
  left: 416px;
}
.terCom {
  position: absolute;
  top: 351px;
  left: 347px;
  width: 586px;
  height: 210px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 34px;
  color: #ffffff;
  opacity: 0.88;
  text-align: left;
}
#terComWM {
  top: 337px;
  left: 314px;
  width: 705px;
  height: 220px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 38px;
  color: #ffffff;
  /* opacity: 0.88; */
}
#terComRSW {
  top: 352px;
  left: 881px;
  width: 644px;
  height: 200px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 34px;
  color: #ffffff;
  opacity: 0.88;
}
#terComZJK {
  top: 355px;
  left: 912px;
  width: 603px;
  height: 200px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 38px;
  color: #ffffff;
  opacity: 0.88;
}
/* .intro {
  width: 1226px;
  height: 71px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 38px;
  color: #666666;
  opacity: 1;
  text-align: left;
  margin: 14px auto 60px;
} */
.intro {
  position: relative;
  box-sizing: border-box;
  display: flex;
  width: 1226px;
  height: 90px;
  font-size: 34px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 70px;
  color: #888888;
  opacity: 1;
  margin: 0px auto 0px;
  justify-content: center;
  padding: 20px 20px;
}
.introTitle {
  position: relative;
  z-index: 9;
  width: 500px;
  height: 68px;
  cursor: pointer;
}
#introTitle {
  border-bottom: 2px solid #e7413b;
  color: #e7413b;
  font-weight: bold;
}
.introTitle:hover {
  color: #e7413b;
}
.teacherCardIndex:hover {
  color: #e7413b;
}
.introBorder {
  position: absolute;
  top: 88px;
  left: 0px;
  width: 1226px;
  height: 1px;
  background-color: #d2d2d2;
}
.teacherCard {
  position: relative;
  box-sizing: border-box;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  height: 142px;
  padding: 30px 349px 0px 349px;
  background-color: #f4f4f4;
}
.teacherCardIndex {
  width: 295px;
  height: 82px;
  background: #ffffff;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;
  font-size: 32px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #7a7a7a;
  line-height: 82px;
  cursor: pointer;
  margin-right: 14px;
}
#teacherCardIndex {
  background: url("../common/images/investTeam/teacherCardIndex.png") no-repeat;
  color: #ffffff;
}
.vid {
  box-sizing: border-box;
  width: 100%;
  height: 676px;
}
.title {
  position: relative;
  width: 710px;
  height: 156px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #1d1d1d;
  opacity: 1;
  margin: 0px auto 0px;
}
.titleL {
  position: absolute;
  top: 80px;
  left: -20px;
  z-index: 9;
}
.titleR {
  position: absolute;
  top: 80px;
  left: 505px;
  z-index: 9;
}
.txtStyle {
  line-height: 170px;
}
.imgStyle {
  position: absolute;
  top: 80px;
  width: 710px;
  height: 16px;
  background: url("../common/images/investTeam/textBJ.png") no-repeat;
}
.subtitle {
  position: absolute;
  top: 120px;
  left: 215px;
  /* width: 280px; */
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 1;
}
#subtitleWM {
  left: 143px;
}
#subtitleRSW {
  left: 150px;
}
#subtitleZJK {
  left: 188px;
}
.video {
  position: relative;
  margin-bottom: 60px;
  width: 1226px;
  height: 461px;
}
.shadow {
  position: absolute;
  top: 0px;
  left: 339px;
  width: 1226px;
  height: 404px;
  opacity: 0.1;

  /* pointer-events: none; */
}
.shadowC {
  position: absolute;
  z-index: 9;
  top: 0px;
  left: 339px;
  width: 1226px;
  height: 404px;
  background-color: #ccc;
  opacity: 0.5;
  pointer-events: none;
}
.shadowY {
  position: absolute;
  z-index: 9;
  top: 0px;
  left: 339px;
  width: 1226px;
  height: 404px;
  background-color: yellow;
  opacity: 0.5;
  pointer-events: none;
}
/* 团队介绍 */
.team {
  width: 100%;
  /* height: 580px; */
  /* background-color: pink; */
}
#teamBJ1 {
  /* background: url("../common/images/investTeam/teamBJ1.png") no-repeat; */
  background-size: 100% 100%;
}
#teamBJ2 {
  background: url("../common/images/investTeam/teamBJ2.png") no-repeat;
  background-size: 100% 100%;
}
#teamBJ3 {
  height: 640px;
  background: url("../common/images/investTeam/teamBJ3.png") no-repeat;
  background-size: 100% 100%;
}
#teamBJ4 {
  height: 665px;
  background: url("../common/images/investTeam/teamBJ4.png") no-repeat;
  background-size: 100% 100%;
}
#teamBJ5 {
  height: 665px;
  background: url("../common/images/investTeam/teamBJ5.png") no-repeat;
  background-size: 100% 100%;
}
.teamCard {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.teamCard > div {
  position: relative;
  width: 397px;
  height: 442px;
  margin-right: 22px;
}
.teamCardA {
  /* margin-left: 338px; */
  background: url("../common/images/investTeam/team1.png") no-repeat;
}
.teamCardB {
  background: url("../common/images/investTeam/team2.png") no-repeat;
}
.teamCardC {
  background: url("../common/images/investTeam/team3.png") no-repeat;
}
.teamCardD {
  background: url("../common/images/investTeam/teamWM1.png") no-repeat;
}
.teamCardE {
  background: url("../common/images/investTeam/teamWM2.png") no-repeat;
}
.teamCardF {
  background: url("../common/images/investTeam/teamWM3.png") no-repeat;
}
.teamCardG {
  background: url("../common/images/investTeam/teamR1.png") no-repeat;
}
.teamCardH {
  background: url("../common/images/investTeam/teamR2.png") no-repeat;
}
.teamCardI {
  background: url("../common/images/investTeam/teamR3.png") no-repeat;
}
.teamCardJ {
  background: url("../common/images/investTeam/teamZ1.png") no-repeat;
}
.teamCardK {
  background: url("../common/images/investTeam/teamZ2.png") no-repeat;
}
.teamCardL {
  background: url("../common/images/investTeam/teamZ3.png") no-repeat;
}
.teamCardM {
  background: url("../common/images/investTeam/teamCJW1.png") no-repeat;
}
.teamCardN {
  background: url("../common/images/investTeam/teamCJW2.png") no-repeat;
}
.teamCardO {
  background: url("../common/images/investTeam/teamCJW3.png") no-repeat;
}
.teamCardA1 {
  position: absolute;
  top: 164px;
  left: 137px;
  height: 33px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 33px;
  color: #ffffff;
  opacity: 1;
}
#teamCardA1WM {
  top: 156px;
  left: 141px;
  color: #333333;
}
#teamCardA1RSW {
  top: 168px;
  left: 0;
  width: 360px;
  text-align: center;
}
#teamRowRSW {
  padding: 0 40px;
}
#teamCardA1ZJK {
  width: 378px;
  top: 136px;
  left: 0;
  text-align: center;
}
.teamCardA2 {
  display: flex;
  justify-content: space-between;
  align-content: flex-start;
  flex-wrap: wrap;
  box-sizing: border-box;
  height: 200px;
  padding: 0 74px 0 79px;
  margin-top: 234px;
}
#teamCardA2WM {
  margin-top: 225px;
}
#teamCardARSW {
  padding: 0 0;
  margin-top: 246px;
}
#teamCardAZJK {
  margin-top: 199px;
  padding: 0 76px 0 60px;
}
.teamCardA2Row::before {
  position: absolute;
  top: 10px;
  left: -20px;
  width: 12px;
  height: 12px;
  content: "";
  background: url("../common/images/investTeam/team6.png") no-repeat;
}
.teamCardA2Row {
  position: relative;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #ffffff;
  opacity: 0.96;
  text-align: left;
  margin-bottom: 10px;
}
.teamCardA2RowZJK::before {
  position: absolute;
  top: 10px;
  left: -25px;
  width: 12px;
  height: 12px;
  content: "";
  background: url("../common/images/investTeam/team6.png") no-repeat;
}
.teamCardA2RowZJK {
  position: relative;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 26px;
  color: #ffffff;
  opacity: 0.96;
  text-align: left;
  margin-bottom: 10px;
}
#teamCardA2RowZJK {
  width: 300px;
}
.teamCardA2RowWM::before {
  position: absolute;
  top: 10px;
  left: -20px;
  width: 12px;
  height: 12px;
  content: "";
  background: url("../common/images/investTeam/teamWM4.png") no-repeat;
}
#teamCardA2RowWM::before {
  position: absolute;
  top: 12px;
  left: 51px;
  width: 12px;
  height: 12px;
  content: "";
  background: url("../common/images/investTeam/teamWM4.png") no-repeat;
}
.teamCardA2RowWM {
  position: relative;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #666666;
  opacity: 1;
  text-align: left;
  margin-bottom: 10px;
}
.li24 {
  line-height: 24px;
}
#teamCardA2RowWM {
  width: 261px;
  text-align: left;
  padding-left: 71px;
}

.teamCardA2RowRSW {
  box-sizing: border-box;
  position: relative;
  text-align: left;
  width: 360px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #666;
  opacity: 1;
  margin-bottom: 10px;
  padding: 0 50px;
}
/* //成员介绍 */
.member {
  width: 100%;
  height: 567px;
  background-color: #fff;
}
.memberS {
  position: relative;
  display: flex;
  justify-content: center;
  width: 1240px;
  /* overflow-x: hidden; */
  margin: 0 auto;
}
.memberR {
  cursor: pointer;
  position: absolute;
  top: 84px;
  right: -80px;
}
.memberL {
  cursor: pointer;
  position: absolute;
  top: 84px;
  left: -80px;
}
.memnerCardHD {
  display: flex;
  position: relative;
  width: 1240px;
  height: 325px;
  overflow-x: hidden;
}
.memnerCardBox {
  position: absolute;
  left: -100%;
  display: flex;
  transition: 1s left ease;
  /* transform: translateX(-1230px); */
}
.memnerCardItem {
  display: flex;
  width: 1240px;
  overflow-x: hidden;
  justify-content: center;
}
.memnerCardItem1 {
  left: 1230px;
  display: flex;
  width: 1240px;
  overflow-x: hidden;
}
.memberCard {
  min-width: 234px;
  min-height: 325px;
  margin-left: 14px;
}
.memberImg {
  position: relative;
  width: 234px;
  height: 234px;
}
.memberImg1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 58px;
  height: 58px;

  background: url("../common/images/investTeam/member.png") no-repeat;
}
.memberImg2 {
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  width: 234px;
  height: 48px;
  background: rgba(0, 0, 0, 0.39);
  /* opacity: 0.5; */
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 48px;
  color: #ffffff;
  opacity: 1;
}
.memberImg2_1 {
  width: 20px;
  height: 0px;
  border: 1px solid #ffffff;
  opacity: 1;
  margin-right: 10px;
  margin-top: 25px;
}
.memberImg2_3 {
  width: 20px;
  height: 0px;
  border: 1px solid #ffffff;
  opacity: 1;
  margin-left: 10px;
  margin-top: 25px;
}
.memberImg3 {
  display: inline-block;
  width: 234px;
  height: 234px;
}
.memberImg4 {
  position: absolute;
  top: 210px;
  left: 35px;
  width: 30px;
  height: 0px;
  border: 1px solid #ffffff;
  opacity: 1;
}
.memberImg4_Z {
  position: absolute;
  top: 210px;
  left: 19px;
  width: 20px;
  height: 0px;
  border: 1px solid #ffffff;
  opacity: 1;
}
.memberImg5_Z {
  position: absolute;
  top: 210px;
  left: 195px;
  width: 20px;
  height: 0px;
  border: 1px solid #ffffff;
  opacity: 1;
}
.menberName {
  display: flex;
  height: 33px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 33px;
  color: #333333;
  opacity: 1;
  margin-top: 20px;
}
.menberName1 {
  width: 4px;
  height: 14px;
  background-color: #e7413b;
  margin: 10px 12px 0 10px;
}
.menberLv {
  height: 28px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 28px;
  color: #333333;
  opacity: 1;
  margin: 16px 0 0 10px;
  text-align: left;
}
.menberNum {
  margin: 16px 0 0 10px;
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  text-align: left;
  opacity: 1;
}
.memberZJK_jianjie {
  width: 1226px;
  margin: 60px auto 0px;
}
.fenGe {
  display: flex;
}
.fenGeL {
  width: 594px;
  height: 0px;
  opacity: 1;
  border: 1px solid #d5d5d5;
  margin-top: 3px;
}
.fenGeR {
  width: 7px;
  height: 7px;
  background: #d5d5d5;
  opacity: 1;
  border-radius: 3px;
  margin: 0px 15px 0 16px;
}
.jianjieTXT {
  width: 1226px;
  height: 109px;
  font-size: 24px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 38px;
  /* -webkit-background-clip: text;
-webkit-text-fill-color: transparent; */
  margin: 19px auto 0px;
  text-align: left;
}
/* 分页 */
.Pagination {
  width: 100%;
  height: 1556px;
  background: rgba(244, 244, 244, 0.39);
  opacity: 1;
}
.showMember {
  box-sizing: border-box;
  display: flex;
  position: relative;
  width: 1226px;
  height: 234px;
  background: rgba(255, 255, 255, 0.39);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 8px;
  margin: 0px auto 20px;
  padding-left: 268px;
}
.showMemberBjImg {
  position: absolute;
  top: -10px;
  left: 10px;
  width: 241px;
  height: 234px;
  background: rgba(0, 0, 0, 0);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 8px;
  background: url("../common/images/investTeam/bjl.png") no-repeat;
  background-size: 100% 100%;
}
.showMemberTopL {
  position: absolute;
  z-index: 99;
  top: -10px;
  left: 20px;
  width: 32px;
  height: 40px;
  background: url("../common/images/investTeam/showMemberTopL.png") no-repeat;
}
.showMemberImg {
  position: absolute;
  top: -10px;
  left: 10px;
  width: 234px;
  height: 234px;
  background: rgba(0, 0, 0, 0);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 8px;
  background-size: 100% 100%;
  z-index: 9;
}
.showMemberCom {
  width: 100%;
}
.showMemberBj {
  position: absolute;
  top: 10px;
  right: 16px;
  width: 158px;
  height: 94px;
  background: url("../common/images/investTeam/bjr.png") no-repeat;
}
.name {
  width: 140px;
  height: 33px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 33px;
  color: #333333;
  opacity: 1;
  text-align-last: left;
  margin: 26px 0 14px 0px;
}
.number {
  display: flex;
}
.number1 {
  width: 24px;
  height: 24px;
  background: url("../common/images/investTeam/icon.png") no-repeat;

  opacity: 1;
  margin-top: 2px;
}
.number2 {
  width: 230px;
  height: 28px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 28px;
  color: #404040;
  opacity: 1;
  margin-left: 10px;
  text-align: left;
}
.number3 {
  width: 24px;
  height: 24px;
  opacity: 1;
  margin-top: 2px;
  background: url("../common/images/investTeam/iconB.png") no-repeat;
}
.number4 {
  width: 280px;
  height: 28px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 28px;
  color: #404040;
  opacity: 1;
  margin-left: 10px;
}
.introduce {
  width: 936px;
  height: 89px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 32px;
  color: #666666;
  opacity: 1;
  text-align: left;
}
#FY /deep/ .el-pager .number {
  border-radius: 4px;
}
#FY /deep/ .el-pager .active {
  background-color: #e7413b;
}
#FY /deep/ .el-pager .number:not(.active):hover {
  color: #666;
}
/* 視頻 */
.videoDAbox,
.videoDBbox {
  position: relative;
}
.banmain {
  height: 460px;
}

.videoDA,
.videoDB,
.videoDC,
.videoDD {
  width: 820px;
  height: 460px;
}
.videoDAbox .play,
.videoDBbox .play {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 400px;
  /* background: linear-gradient(rgba(80, 80, 80, 0.3), rgba(80, 80, 80, 0)); */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  cursor: pointer;
}
.videoDAbox .playing,
.videoDBbox .playing {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -45px;
  margin-top: -60px;
}
.videoDAbox .playbtn,
.videoDBbox .playbtn {
  display: block;
  width: 90px;
  height: 90px;
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/investTeam.vue